import { variant } from 'styled-system';
export const buttonVariant = (props) => {
    const { theme } = props;
    return variant({
        variants: theme.buttons,
    })(props);
};
//# sourceMappingURL=buttonVariant.js.map